/**
 * Environment and Hostname Utilities
 */

/**
 * Check if the current environment/hostname is permitted to view the Executive Operations Dashboard.
 * Allowed: localhost, 127.0.0.1, and adm-dev.skai1.com
 * @returns {boolean}
 */
export const isDashboardAllowed = () => {
  if (typeof window === 'undefined') return true;
  const host = window.location.hostname.toLowerCase();
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === 'adm-dev.skai1.com' ||
    host.endsWith('.localhost')
  );
};
